module.exports = __webpack_public_path__ + "img/chat-details2.72eebcd1.png";